<template>
  <div class="buyerShop">
    <el-tabs v-if="creatingBtn" v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane :label="$t('crm.createdList')" name="created"></el-tab-pane>
      <el-tab-pane :label="$t('crm.creatingList')" name="creating"></el-tab-pane>
    </el-tabs>
    <CreatedList
      v-if="activeTab === 'created' || !creatingBtn"
      :systemList="systemList"
      :vendorList="vendorList"
      :vendorAliasList="vendorAliasList"
      :vendorTypeList="vendorTypeList"
      :countryList="countryList"
      :vendorStatusList="vendorStatusList"
      :unitList="unitList"
      :vendorProductSourceTypeList="vendorProductSourceTypeList"
      :supplyPriceMethodList="supplyPriceMethodList"
      :businessRegionList="businessRegionList"
      :boutiqueBdList="boutiqueBdList"
      :boutiqueBdMap="boutiqueBdMap"
      :groupByList="groupByList"
    ></CreatedList>
    <CreatingList
      v-if="activeTab === 'creating' && creatingBtn"
      :systemList="systemList"
      :vendorList="vendorList"
      :vendorTypeList="vendorTypeList"
      :countryList="countryList"
      :vendorStatusList="vendorStatusList"
      :unitList="unitList"
      :vendorProductSourceTypeList="vendorProductSourceTypeList"
      :supplyPriceMethodList="supplyPriceMethodList"
      :businessRegionList="businessRegionList"
      :boutiqueBdList="boutiqueBdList"
      :boutiqueBdMap="boutiqueBdMap"
      :approvalUserList="approvalUserList"
      :approvalUserMap="approvalUserMap"
      :createVendorStatus="createVendorStatus"
      :createVendorStatusMap="createVendorStatusMap"
      :storeNameList="storeNameList"
    ></CreatingList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getComboVendorList,
  getGroupListByName,
  getCRMVendorList,
} from './api';
import {
  getSystemList,
  getVendorType,
  getCountryList,
  getVendorStatusList,
  getUnitList,
  getProductSourceTypeList,
  getSupplyPriceMethodList,
  getBusinessRegionList,
  getUserList,
} from '../../buyershop/cn/api';
import {
  getDictList,
  getCreatingVendorNameList,
} from './api';
import CreatedList from './list/created.vue';
import CreatingList from './list/creating.vue';

function checkPermission(list, code) {
  if (!list) {
    return false;
  }
  for (let i = 0; i < list.length; i++) {
    const menu = list[i];
    if (menu.code.endsWith('商家CRM')) {
      for (let j = 0; j < menu.children.length; j++) {
        const sub = menu.children[j];
        if (sub.code === code) {
          return true;
        }
      }
    }
  }
  return false;
}

export default {
  data() {
    return {
      systemList: [],
      vendorList: [],
      vendorAliasList: [],
      vendorTypeList: [],
      countryList: [],
      vendorStatusList: [],
      unitList: [],
      vendorProductSourceTypeList: [],
      supplyPriceMethodList: [],
      businessRegionList: [],
      boutiqueBdList: [],
      boutiqueBdMap: {},
      approvalUserList: [],
      approvalUserMap: {},
      createVendorStatus: [],
      createVendorStatusMap: {},
      storeNameList: [],
      groupByList: [],
      activeTab: this.$route.query.tab || 'created',
    };
  },
  components: {
    CreatedList,
    CreatingList,
  },
  computed: mapState({
    creatingBtn: (state) => checkPermission(state.app.menuList, 'hide-新店创建中'),
  }),
  mounted() {
    this.init();
  },
  methods: {
    handleClick() {
      this.$router.replace({
        path: '/crm/cn/list?tab=' + this.activeTab,
      });
    },
    init() {
      getComboVendorList(true).then(res => {
        if (res.data) {
          this.vendorAliasList = (res.data.data || []).map(item => ({
            label: item.vendorNameAlias,
            value: item.vendorId,
          }));
        }
      })
      getCRMVendorList().then(res => {
        if (res.data) {
          this.vendorList = (res.data.data || []).map(item => ({
            label: item.vendorName,
            value: item.vendorId,
          }));
        }
      })
      getSystemList().then(res => {
        if (res.data && res.data.success) {
          this.systemList = (res.data.data || []).map(item => ({
            label: item.systemName,
            value: item.vendorSystemId,
          }));
        }
      })
      getVendorType().then(res => {
        if (res.data) {
          // 过滤奥莱村 寄售 识季测试业务
          this.vendorTypeList = (res.data.data || []).filter(item => {
            return item.value !== 6 && item.value !== 4
          }).map(item => ({

            label: item.desc,
            value: item.value,
          }));
        }
      })
      getCountryList().then(res => {
        if (res.data) {
          this.countryList = (res.data.data || []).map(item => ({
            label: item.name,
            value: item.addressCountryId,
          }));
        }
      })
      getVendorStatusList().then(res => {
        if (res.data) {
          this.vendorStatusList = (res.data.data || []).map(item => ({
            label: item.desc,
            value: item.value,
          }));
        }
      })
      getUnitList().then(res => {
        if (res.data && res.data.success) {
          this.unitList = (res.data.data || []).map(item => ({
            label: item.fromCountry,
            value: item.fromCountry,
            key: item.productExchangeRateId,
          }));
        }
      })
      getProductSourceTypeList().then(res => {
        if (res.data) {
          this.vendorProductSourceTypeList = (res.data.data || []).map(item => ({
            label: item.desc,
            value: item.value,
          }));
        }
      })
      getSupplyPriceMethodList().then(res => {
        if (res.data) {
          this.supplyPriceMethodList = (res.data.data || []).map(item => ({
            label: item.desc,
            value: item.value,
          }));
        }
      })
      getBusinessRegionList().then(res => {
        if (res.data) {
          this.businessRegionList = (res.data.data || []).filter(item => {
            // 过滤奥莱村 寄售 识季测试业务
            return item.businessRegionId !== 8 && item.businessRegionId !== 11 && item.businessRegionId !== 12
          }).map(item => ({
            label: item.businessRegionName,
            value: item.businessRegionId,
          }));
        }
      })
      getUserList().then(res => {
        const map = {};
        this.boutiqueBdList = (res.data || []).map(item => {
          map[item.deptUserId] = item.deptUserName;
          return {
            label: item.deptUserName,
            value: item.deptUserId,
          };
        });
        this.boutiqueBdMap = map;
      })
      getDictList({
        parentCode: 'approval_user',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          this.approvalUserList = (res.data.data || []).map(item => {
            map[item.dictCode] = item.dictValue;
            return item;
          });
          this.approvalUserMap = map;
        }
      });
      getDictList({
        parentCode: 'create_vendor_status',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          this.createVendorStatus = (res.data.data || []).map(item => {
            map[item.dictCode] = item.dictValue;
            return item;
          });
          this.createVendorStatusMap = map;
        }
      });
      getCreatingVendorNameList().then(res => {
        if (res.data && res.data.success) {
          this.storeNameList = res.data.data || [];
        }
      })
      getGroupListByName({
        groupName: '',
      }).then(res => {
        if (res.data && res.data.success) {
          this.groupByList = res.data.data;
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  padding: 20px;
}
.form-btn {
  margin-top: 40px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.tr {
  text-align: right;
}
.f12 {
  font-size: 12px;
}
.red {
  color: red;
}
</style>
<style lang="less">
.searchForm {
  .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
